import React, { useState } from "react";
import QuestionComponent from "./QuestionComponent";
import { Droppable, Draggable } from "@hello-pangea/dnd";

const OptionComponent = ({
  questionId,
  option,
  addChildQuestion,
  updateOption,
  handleImageUpload,
  depth,
  parentCategory,
  updateQuestion,
  addOption,
  allCategories,
  addNewCategory,
  deleteQuestion,
  deleteOption,
  duplicateQuestion,
}) => {
  const [localText, setLocalText] = useState(option.text);
  const [localWeight, setLocalWeight] = useState(option.weightage);

  const onChildDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(option.childQuestions || []);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    updateOption(questionId, option.id, "childQuestions", reordered);
  };

  return (
    <div className="p-2 sm:p-3 md:p-4 border rounded bg-white mb-2 ml-2 sm:ml-4 md:ml-6">
      <div className="flex flex-col md:flex-row justify-between items-start mb-2 md:items-start gap-2 md:gap-4">
        <div className="flex-1">
          <input
            type="text"
            value={localText}
            onChange={(e) => setLocalText(e.target.value)}
            onBlur={() => updateOption(questionId, option.id, "text", localText)}
            className="w-full p-2 sm:p-3 border rounded mb-1 text-black text-sm sm:text-base"
            placeholder="Option Text"
          />
          <input
            type="number"
            value={localWeight}
            onChange={(e) => setLocalWeight(e.target.value)}
            onBlur={() =>
              updateOption(
                questionId,
                option.id,
                "weightage",
                parseInt(localWeight) || 0
              )
            }
            className="w-full p-2 sm:p-3 border rounded mb-1 text-black text-sm sm:text-base"
            placeholder="Weightage"
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageUpload(e, questionId, option.id)}
            className="w-full p-2 sm:p-3 border rounded mb-1 text-black text-sm sm:text-base"
          />
          {option.image && (
            <img
              src={option.image}
              alt="Option Preview"
              className="mt-2 max-w-full sm:max-w-xs md:max-w-sm"
            />
          )}
        </div>

        <div className="flex flex-row md:flex-col ml-0 md:ml-2 gap-1">
          <button
            className="bg-blue-500 text-white px-2 py-1 sm:px-3 sm:py-1.5 rounded text-xs sm:text-sm"
            onClick={() => addChildQuestion(questionId, option.id, parentCategory)}
          >
            +Child Question
          </button>
          <button
            className="bg-red-500 text-white px-2 py-1 sm:px-3 sm:py-1.5 rounded text-xs sm:text-sm"
            onClick={() => deleteOption(questionId, option.id)}
          >
            Delete
          </button>
        </div>
      </div>

      {/* Child Questions */}
      <Droppable droppableId={`child-${option.id}`} type="CHILD">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="ml-4 sm:ml-8 border-l-2 border-gray-300 pl-2 sm:pl-4 overflow-x-auto"
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              maxWidth: `calc(100% - ${depth * 20}px)`,
            }}
          >
            {(option.childQuestions || []).map((child, index) => (
              <Draggable key={child.id} draggableId={child.id} index={index}>
                {(providedDraggable) => (
                  <div
                    ref={providedDraggable.innerRef}
                    {...providedDraggable.draggableProps}
                  >
                    <QuestionComponent
                      question={child}
                      depth={depth + 1}
                      index={`${index + 1}`}
                      dragHandleProps={providedDraggable.dragHandleProps}
                      addOption={addOption}
                      addChildQuestion={addChildQuestion}
                      updateQuestion={updateQuestion}
                      updateOption={updateOption}
                      handleImageUpload={handleImageUpload}
                      allCategories={allCategories}
                      addNewCategory={addNewCategory}
                      deleteQuestion={deleteQuestion}
                      deleteOption={deleteOption}
                      duplicateQuestion={duplicateQuestion}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default OptionComponent;